import { useEffect } from 'react';
import { useVideoPlayerContext } from '@/components/VideoPlayer/VideoPlayerProvider';
import { getVideoElementFromRef } from '@/utils/video-player';
import { usePipPlayerStore } from '@/stores/pip-player.store';

export function usePipVideoAspect() {
    const { activeMediaRef, emitter } = useVideoPlayerContext();
    const setVideoAspectRatio = usePipPlayerStore((s) => s.setVideoAspectRatio);

    useEffect(() => {
        const syncAspect = () => {
            const videoElement = getVideoElementFromRef(activeMediaRef);
            if (!videoElement) return;
            const { videoWidth, videoHeight } = videoElement;
            if (!videoWidth || !videoHeight) return;
            setVideoAspectRatio(videoWidth / videoHeight);
        };

        syncAspect();
        return emitter.on('loadedmetadata', syncAspect);
    }, [activeMediaRef, emitter, setVideoAspectRatio]);
}
